import React from "react";
import "./Hero2.css";

const Hero2 = (props) => {
  return (
    <section className="hero2" aria-label={props.title || "Page banner"}>
      <div className={props.cName}>
        <img
          className="hero2-img"
          alt={props.imageAlt || props.title || "Banner image"}
          src={props.heroImg}
          loading="lazy"
          width="1920"
          height="1080"
          title={props.title}
        />
        <div className="hero2-text">
          <h1>{props.title}</h1>
          <p>{props.text}</p>
        </div>
      </div>
    </section>
  );
};

export default Hero2;
